/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Box, styled } from "@mui/material";
import { DocumentLink } from "components/Common/DocumentLink";
import { Title } from "components/Common/Title";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { AboutListItem } from "const";

const Container = styled(Box)(({ theme }) => ({
  padding: 3,
  height: "100%",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Contents = styled(Box)(({ theme }) => ({
  gap: theme.spacing(2),
  flexGrow: 1,
}));

const Attention = styled(Box)(({ theme }) => ({
  padding: "1rem",
}));

/**
 * Component of user guide screen
 * @return{FC} Component
 */
export const About: FC = () => {
  const { t } = useTranslation();
  const aboutItems: Array<AboutListItem> = [
    {
      title: t("AWVUI-MSG141"),
      url: `${process.env.PUBLIC_URL}/manual/ui_manual.pdf`,
    },
    {
      title: t("AWVUI-MSG142"),
      url: `${process.env.PUBLIC_URL}/manual/ui_manual.pdf`,
    },
  ];
  return (
    <>
      <Title title={t("AWVUI-MSG139")} />
      <Container>
        <Contents>
          <ul>
            {aboutItems.map((item: AboutListItem) => (
              <li key={item.title}>
                <DocumentLink name={item.title} url={item.url} />
              </li>
            ))}
          </ul>
        </Contents>
        <Attention>{t("AWVUI-MSG140")}</Attention>
      </Container>
    </>
  );
};
